import gql from 'graphql-tag'

// Rules: vhs-gql/docs/requirements/voucher-tags.md.

export const GET_TAGS = gql`
  query GetTags($search: String) {
    tags(search: $search) {
      id
      name
      voucher_count
      can_manage
    }
  }
`

export const ADD_VOUCHER_TAG = gql`
  mutation AddVoucherTag($voucherId: ID!, $tagId: Int, $name: String) {
    addVoucherTag(voucherId: $voucherId, tagId: $tagId, name: $name) {
      id
      name
    }
  }
`

export const REMOVE_VOUCHER_TAG = gql`
  mutation RemoveVoucherTag($voucherId: ID!, $tagId: Int!) {
    removeVoucherTag(voucherId: $voucherId, tagId: $tagId) {
      id
      name
    }
  }
`

export const RENAME_TAG = gql`
  mutation RenameTag($id: Int!, $name: String!) {
    renameTag(id: $id, name: $name) {
      id
      name
      voucher_count
      can_manage
    }
  }
`

export const DELETE_TAG = gql`
  mutation DeleteTag($id: Int!) {
    deleteTag(id: $id)
  }
`
